import { Col, Row } from 'antd'
import { transparentize } from 'polished'
import React, { Fragment, PureComponent } from 'react'
import styled from 'styled-components'
import { Flex } from '../styles/styled-common'

const ItemContainer = styled.div`
  background: ${p => p.theme.offBlack};
  border-radius: 8px;
  margin-bottom: 2em;
  overflow: hidden;
`

const NotesContainer = styled(Flex)`
  background: ${p => transparentize(0.6, p.theme.antLink)};
  position: relative;
  border-bottom-right-radius: 8px;

  .circle-seperator {
    margin: 0 10px;

    &:last-child {
      display: none;
    }
  }
`
const NotesHeadline = styled.div`
  background: ${p => transparentize(0.6, p.theme.antLink)};
  padding: 6px;
  flex: 184px 0 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  font-family: 'Kanit';
  font-weight: bold;
`

export default class HostsListItem extends PureComponent {
  render() {
    const { host, columns, ...props } = this.props

    let moneyBack = 'Unknown'

    const notes = [
      ...new Set((host.notes || []).concat(host.gameInfo.notes || [])),
    ]

    if (host.moneyBack) {
      if (host.moneyBack.time < 0) moneyBack = 'No'
      else if (host.moneyBack.time > 0) {
        moneyBack = `${host.moneyBack.time} ${
          host.moneyBack.unit === 'd' ? 'Days' : 'Hours'
        }`
      }
    }

    return (
      <ItemContainer {...props}>
        <Row
          gutter={{
            xs: 2,
            sm: 3,
            md: 3,
            lg: 8,
            xl: 20,
            xxl: 20,
          }}
          style={{ padding: '10px 20px' }}
          type="flex"
          justify="space-between"
        >
          {columns.map(({ layout, render, columnKey }) => (
            <Col
              key={columnKey}
              span={Math.floor(24 / columns.length)}
              {...layout}
            >
              {render(host)}
            </Col>
          ))}
        </Row>

        {notes.length || host.moneyBack || host.established ? (
          <NotesContainer flexWrap="nowrap" justifyContent="start">
            <NotesHeadline>EXTRA</NotesHeadline>
            <div style={{ flex: 'auto 1', padding: '4px 8px 4px 16px' }}>
              {host.established && (
                <Fragment>
                  <span>
                    Established in {new Date(host.established).getFullYear()}
                  </span>
                  <span className="circle-seperator">•</span>
                </Fragment>
              )}
              {host.moneyBack && (
                <Fragment>
                  <span>{moneyBack} Money Back Guarantee</span>
                  <span className="circle-seperator">•</span>
                </Fragment>
              )}
              {notes.map((note, i) => (
                <Fragment key={`note${i}`}>
                  <span>{note}</span>
                  <span className="circle-seperator">•</span>
                </Fragment>
              ))}
            </div>
          </NotesContainer>
        ) : null}
      </ItemContainer>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsListItem.jsx